import type { PricingItem } from '@/types'

/**
 * Default pricing formula for fresh accounts going through the onboarding wizard.
 *
 * Matches the onboarding.wizard.step_2_formula_banner_body copy ("We've
 * pre-filled a typical Thai apartment setup for you"; EP-114 T010 — this key
 * replaced the retired step-2 explainer-copy key that carried the same
 * promise): Rent ฿5,000 + Water ฿18/u + Electricity ฿7/u. Common fees are
 * opt-in; metered unit labels use the pricing engine's default. The
 * rent line is a display anchor — billing single-sources rent from
 * unit.price (the engine skips any formula "rent" line, EP-55 F-001) — so it is
 * inherited into the step-3 quick-add unit rent (PropertyRoomsFields), which sets
 * the real rent. Changing it here changes the step-3 default too.
 *
 * Locale-free: name strings are English placeholders resolved at render-time via i18n
 * (properties.pricing_editor.presets.{key}.name). Consumer is responsible for
 * populating display names from the key when rendering.
 *
 * Closes EP-52 F-020 (copy↔state contract — see task-113 vitest; the "seed
 * array is non-empty" half of that contract still applies post-EP-114 T010,
 * see wizard-copy-contract.test.ts).
 */
export const WIZARD_DEFAULT_PRICING_FORMULA: readonly PricingItem[] = Object.freeze([
  // Rent is a `fixed` line, so its value lives in `amount` (PricingFormulaEditor
  // reads amount for fixed items; rate is for metered/percentage).
  Object.freeze({ key: 'rent',        name: 'Rent',        type: 'fixed'      as const, amount: 5000 }),
  Object.freeze({ key: 'water',       name: 'Water',       type: 'metered'    as const, rate: 18 }),
  Object.freeze({ key: 'electricity', name: 'Electricity', type: 'metered'    as const, rate: 7 }),
])
